import { useEffect } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

//? import components
import ConfirmPassword from "../Auth/ConfirmPassword";

// import { LockPersonIcon } from "@mui/icons-material/LockPersonIcon";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useSelector, useDispatch } from "react-redux";

import {
  getDev,
  twoFactorAuth,
  getQrCode,
  getRecoveryCodes,
  regenerateRecoveryCodes,
  deleteTwoFactoAuthentication,
} from "../../features/Dev/devSlice";
import { toogleConfirmPassword } from "../../features/modals/modalSlice";
import SVGComponent from "./SVGComponent";

const TwoFactorAuth = () => {
  const [twoFa, setTwoFa] = useState(false);
  // const user = useSelector((state) => state.dev);
  const { confirmPassword } = useSelector((state) => state.modal);
  const { errorMsg, dev, qrCode, recoveryCodes } = useSelector(
    (state) => state.dev
  );
  const dispatch = useDispatch();

  console.log(qrCode);

  const { has2fa } = dev;
  useEffect(() => {
    dispatch(getDev());
    // setTwoFa(!twoFa);
  }, [has2fa]);

  const handleOpenConfirmPassword = () => {
    // dispatch(toggleLogin());
    dispatch(toogleConfirmPassword());
  };

  const enable2fa = () => {
    dispatch(twoFactorAuth());
    dispatch(getDev());
  };

  const fetchQrCode = () => {
    dispatch(getQrCode());
  };

  const fectRecoveryCodes = () => {
    dispatch(getRecoveryCodes());
  };

  const fectRegeneratedRecoveryCodes = () => {
    dispatch(regenerateRecoveryCodes());
  };

  const destroy2fa = () => {
    dispatch(deleteTwoFactoAuthentication());
    dispatch(getDev());
  };

  return (
    <>
      <Grid container spacing={4} direction="column">
        <Grid item>
          <Container maxWidth="xs">
            <Box>
              <Paper elevation={2}>
                <Box
                  xs={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                  p={3}
                >
                  <Box p={1} sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography color="warning" variant="h5">
                      2 Factor Settings
                    </Typography>
                  </Box>
                  <Box>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-around" }}
                    >
                      {has2fa === true ? (
                        <>
                          <Button
                            variant="outlined"
                            onClick={destroy2fa}
                            color="error"
                          >
                            Disable 2FA
                          </Button>{" "}
                          <LockOutlinedIcon />
                        </>
                      ) : (
                        <>
                          <Button
                            color="warning"
                            variant="outlined"
                            onClick={enable2fa}
                          >
                            Enable 2FA
                          </Button>

                          <LockOpenOutlinedIcon />
                        </>
                      )}
                    </Box>
                    {/* <Button onClick={handleOpenConfirmPassword}>
                      confirm password
                    </Button> */}
                  </Box>
                  {has2fa && (
                    <Box
                      pt={3}
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Button
                        variant="outlined"
                        coolor="info"
                        onClick={fetchQrCode}
                      >
                        {" "}
                        Get qrCode{" "}
                      </Button>
                      <Button
                        variant="outlined"
                        color="info"
                        onClick={fectRecoveryCodes}
                      >
                        {" "}
                        Get recovery code{" "}
                      </Button>
                    </Box>
                  )}
                </Box>
              </Paper>
            </Box>
          </Container>
        </Grid>
        <Grid item>
          <Container maxWidth="sm">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
              p={2}
            >
              {/* {recoveryCodes.length > 0 ||
                (qrCode && ( */}
              {has2fa && (
                <Grid container spacing={2}>
                  {/* {qrCode && (
                    <Grid item xs={6}>
                      <SVGComponent qr={qrCode} />
                    </Grid>
                  )} */}
                  {/* <Box>{qrCode}</Box> */}
                  {/* {qrCode} */}
                  {/* <img alt="dfghjk" src={qrCode} /> */}

                  <Box component="img" src={qrCode} />

                  {recoveryCodes.length > 0 && (
                    <Grid item xs={6}>
                      <Box
                      // sx={{ display: "flex", justifyContent: "center" }}
                      >
                        <Paper elevation={2}>
                          <Box
                            p={1}
                            sx={{
                              diaplay: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                diaplay: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                              }}
                            >
                              {recoveryCodes.length > 0 &&
                                recoveryCodes.map((recoveryCode) => (
                                  <Typography sx={{ textAlign: "center" }}>
                                    {recoveryCode}
                                  </Typography>
                                ))}
                            </Box>
                            <Box pt={1}>
                              <Button
                                onClick={fectRegeneratedRecoveryCodes}
                                color="success"
                                variant="outlined"
                              >
                                Regenerate Codes
                              </Button>
                            </Box>
                          </Box>
                        </Paper>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              )}
            </Box>
          </Container>
        </Grid>
      </Grid>

      <ConfirmPassword />
    </>
  );
};

export default TwoFactorAuth;
